@if(field){
<div [formGroup]="form" class="field-container">
    <mat-form-field class="dynamic-mat-form-field" appearance="outline"
        floatLabel="auto"
        [ngClass]="{'invalid-control': form.get('course')?.invalid && form.get('course')?.touched}">
        <mat-label>{{field.displayTranformation===DisplayTransformation.none? field['displayName'] : field['displayName'] |camelCase}}</mat-label>
        @if(field['isAutoComplete']){
        <input [id]="formFieldName" (keyup)="onAutoCompleteInputChange()" (click)="openDropdown()" class="autocomplete-input-field" matInput
            [placeholder]="field.displayTranformation===DisplayTransformation.none? field['displayName'] : (field['displayName'] | camelCase)"
            [(ngModel)]="autoCompleteInput" [ngModelOptions]="{ standalone: true }" (keydown.enter)="$event.preventDefault()"
            [disabled]="!!field['disabled'] || !!field['isLoading']">
        }
        <mat-select [id]="formFieldName" #dropdownRef [multiple]="field.multiple" selectAll
            [formControlName]="formFieldName" (selectionChange)="handleSelection(field['fieldName'],$event.value)"
            [ngClass]="{'dynamic-input-select-disabled':field['disabled'], 'auto-complete-select': field['isAutoComplete'], 'loading-select': field['isLoading']}"
            (openedChange)="onOpenClose($event)">
            @if(field.multiple){
            @if(field['options'] && field['options'].length>0){
            <mat-option class="select-all-option" [class.is-all-selected]="isAllSelected()" [value]="selectAllSentinel"
                (onSelectionChange)="onSelectAllOptionChange($event)">Select All</mat-option>
            }@else if(!field['isLoading']){
            <mat-option [value]="" [disabled]="true">Select</mat-option>
            }

            }
            @if(!field.multiple){
            <mat-option [value]="" *ngIf="field['showSelect'] && !field['isLoading']">Select</mat-option>
            }
            <mat-option *ngIf="field['isLoading']" disabled>
                <mat-progress-spinner diameter="20" mode="indeterminate" color="primary"
                    style="display: inline-block; vertical-align: middle;">
                </mat-progress-spinner>
                <span style="margin-left: 8px;">Fetching Records...</span>
            </mat-option>
            @for (opt of field.options ?? [] | visibleOptions:field:autoCompleteFilter; track idx; let idx = $index){
            <mat-option [value]="opt['fieldValue']">
                {{field.displayTranformation===DisplayTransformation.none?opt['fieldLabel']:
                field.displayTranformation===DisplayTransformation.uppercase ? (opt['fieldLabel'] | uppercase) :
                opt['fieldLabel'] | camelCase }}
            </mat-option>}
        </mat-select>
        @if(field['isLoading']){
        <mat-progress-spinner matSuffix class="field-loading-spinner" diameter="18" mode="indeterminate" color="primary"></mat-progress-spinner>
        }
        @if(form.get(field['fieldName'])?.hasError('required')&& form.get(field['fieldName'])?.touched){
        <mat-error> {{field.displayName | camelCase}} is required</mat-error>
        }

    </mat-form-field>
</div>
}